import React from 'react';

const DownloadCovers = ({ modules, backgroundCover }) => (
  <React.Fragment>
    {Object.keys(modules).map(module => {
      return modules[module].cover ? (<img key={module} src={`/files/${modules[module].cover}`} />) : '';
    })}
    {backgroundCover && (<img src={`/files/${backgroundCover}`} />)}
  </React.Fragment>
);

DownloadCovers.propTypes = {
};

export default DownloadCovers;



// WEBPACK FOOTER //
// ./src/components/login/downloadCovers/DownloadCovers.jsx